/**
 * Created with IntelliJ IDEA.
 * User: FlyingAnt
 * Date: 2/3/15
 * Time: 11:03 AM
 * To change this template use File | Settings | File Templates.
 */
let Backbone = require("backbone");

let main = function () {
    return Backbone.View.extend({
        events: {
            "click a": "anchorClicked"
        },

        initialize: function () {

        },
        anchorClicked: function(e) {
            window.location.href = $(e.target).attr("href");
            return false;
        }
    });
};

let exportedValue = main();
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/view/settings/SettingsNavigatorView.js